import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AlertComponent } from './alert.component';
import { AlertTemplate } from './alert.template';

@Injectable({
    providedIn: 'root'
})

export class AlertService {
    constructor(public dialog: MatDialog, private alertTemplate: AlertTemplate) { }

    openInfoModal(id:number, language: string) {
        this.dialog.closeAll();
        let template = this.alertTemplate.template(id,language);
        this.dialog.open(AlertComponent, {
            data: {
                title: template[0].title,
                html: template[0].html
            }
        });
    }

    openInfoSessionModal(id:number, language: string) {
        this.dialog.closeAll();
        let template = this.alertTemplate.template(id,language);
        this.dialog.open(AlertComponent, {
            disableClose: true,
            data: {
                title: template[0].title,
                html: template[0].html
            }
        });
    }

    openResponseModal(title: string, message: string) {
      this.dialog.closeAll();
      this.dialog.open(AlertComponent, {
          data: {
              title: title,
              html: message
          }
      });
    }

    openConfirmModal(title: string, html: any) {
      this.dialog.closeAll();
      this.dialog.open(AlertComponent, {
          data: {
              title: title,
              html: html
          }
      });
    }

}
